// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1s0QY","productName":"Table_productName__YnlE0"};